import React from 'react'
import { NavLink } from 'redux-first-router-link'

import { Icon } from 'components/shared/Icon/Icon'
import { FadeScale } from 'components/shared/Transitions/FadeScale/FadeScale'

import styles from './NavigationItem.module.scss'

export const NavigationItem = ({
  icon,
  label,
  to,
  isActive = undefined,
  isCollapsed = false,
  isExact = false,
}) => {
  const ref = React.useRef()

  return (
    <li className={styles.item}>
      <NavLink
        activeClassName={styles.active}
        className={styles.link}
        to={to}
        isActive={isActive}
        exact={isExact}
      >
        <Icon className={styles.icon} size={22} {...{ icon }} />
        <FadeScale
          className={styles.label}
          ref={ref}
          isInitialised={!isCollapsed}
        >
          <span ref={ref}>{label}</span>
        </FadeScale>
      </NavLink>
    </li>
  )
}
